import React from 'react';
import { Link } from 'react-router'
import $ from 'jquery'

let config = require('config');

class WorksTypeBig extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
    }
    this.mouseEnter = this.mouseEnter.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)
  }

  componentDidMount() {
  }

  mouseEnter(e) {
    var target = $(e.currentTarget)
    target.closest(".content__block").find(".block__thumbnail a").addClass("hover")
  }

  mouseLeave(e) {
    var target = $(e.currentTarget)
    target.closest(".content__block").find(".block__thumbnail a").removeClass("hover")
  }

  render() {
    const { works } = this.props;
    var self = this
    return (
      <div className="works__list type_big">
        { works ?
            works.contents.map(function(work, i) {
              return (
                <div key={i} className="content__block">
                  <div className="block__left">
                    <div className="left__title"><Link onMouseEnter={self.mouseEnter} onMouseLeave={self.mouseLeave} to={"/works/" + work.id + "/"}>{work.title}</Link></div>
                    <div className="left__members">
                      <ul>
                        { work.member.map(function(m, j) {
                          return (
                            <li key={j}><Link to={"/member/" + m.id + "/"}>{m.name_en}</Link></li>
                          )
                        })}
                      </ul>
                    </div>
                    { work.is_former_job ?
                        <div className="left__note">
                          <span>前所属会社での実績</span>
                        </div>
                      :null
                    }
                  </div>
                  <div className="block__thumbnail">
                    <Link className="filter" to={"/works/" + work.id + "/"}><img src={work.thumbnail.url} alt={work.title} /></Link>
                  </div>
                </div>
              )
            })
          :null
        }
      </div>
    );
  }
}

WorksTypeBig.displayName = 'WorksTypeBig';
WorksTypeBig.propTypes = {};
WorksTypeBig.defaultProps = {};

export default WorksTypeBig;



// WEBPACK FOOTER //
// ./components/WorksTypeBig.js